module.exports = __webpack_public_path__ + "img/Support-skill-303.ea1223f6.png";